/** @jsxImportSource @emotion/react */
import { Input, Typography, useTheme } from '@quickbit/qb-design-system';
import { SettlementReportAdjustment } from 'tabs/AccountingSettlement/types';
interface Props {
  adjustments: SettlementReportAdjustment[];
}

export const Adjustments = ({ adjustments }: Props) => {
  const { spacing } = useTheme();

  if (!adjustments.length) return null;

  return (
    <>
      <Typography variant="subtitle">Adjustments</Typography>
      {adjustments.map((adjustment) => (
        <div
          key={adjustment.uuid}
          css={{
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gap: spacing.xxs,
          }}
        >
          <div css={{ display: 'flex', gap: spacing.xxs }}>
            <Input label={'Label'} value={adjustment.label} />
            <Input
              type="number"
              label={'Amount'}
              value={adjustment.amount.toString()}
            />
          </div>
        </div>
      ))}
    </>
  );
};
